import PropTypes from "prop-types";
import * as React from "react";

export const FilterButton = ({name, label, onClick, filterState}) => (
    <li onClick={onClick}>
        <div className={name + (filterState === true ? " checked" : "")} data-control-type="validationfilter">
            <span/>
        </div>
        {label}
    </li>
);

FilterButton.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    onClick: PropTypes.func,
    filterState: PropTypes.bool,
};

const filters = [
    {
        key: "blocking",
        label: "Blocking",
    },
    {
        key: "illegal",
        label: "Illegal",
    }, {
        key: "warning",
        label: "Warning",
    }, {
        key: "ok",
        label: "OK",
    }, {
        key: "all",
        label: "All Levels",
    },
];

const PanelHeading = props => (<div className="panel-heading">
        <div className="filters">
            <ul>
                {
                    filters.map(({key, label}) =>
                        (<FilterButton
                            key={key}
                            name={key}
                            label={key === "illegal" && props.illegalLabel
                                ? props.illegalLabel
                                : label}
                            onClick={() => props.onFilterClick(key)}
                            filterState={props[key]}
                        />))
                }
            </ul>
        </div>
    </div>);

PanelHeading.propTypes = {
    onFilterClick: PropTypes.func.isRequired,
    illegalLabel: PropTypes.string,
    blocking: PropTypes.bool.isRequired,
    illegal: PropTypes.bool.isRequired,
    warning: PropTypes.bool.isRequired,
    ok: PropTypes.bool.isRequired,
    all: PropTypes.bool.isRequired,
};

export default PanelHeading;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/validationtree/components/PanelHeading.js